/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TChatsMoveToArchiveDesktopModel,
  IChatsMoveToArchiveDesktopRequest,
  IMappers,
  IChatsMoveToArchiveDesktopResponse,
  IChatsMoveToArchiveDesktopResponseError,
  TChatsMoveToArchiveDesktopResponse,
} from './types';

const defaultConfig: TChatsMoveToArchiveDesktopModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'chats',
  pathApi: '/v1/chats/move-to-archive-desktop/',
  hostType: 'api',
} as TChatsMoveToArchiveDesktopModel;

function createChatsMoveToArchiveDesktopModel(
  parameters: IChatsMoveToArchiveDesktopRequest,
): TChatsMoveToArchiveDesktopModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IChatsMoveToArchiveDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IChatsMoveToArchiveDesktopRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchChatsMoveToArchiveDesktop<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IChatsMoveToArchiveDesktopOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TChatsMoveToArchiveDesktopResponse
> {
  const { response, statusCode } = await httpApi.fetch(createChatsMoveToArchiveDesktopModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IChatsMoveToArchiveDesktopResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IChatsMoveToArchiveDesktopResponseError);
    }
  }

  return { response, statusCode } as TChatsMoveToArchiveDesktopResponse;
}

export { defaultConfig, createChatsMoveToArchiveDesktopModel, fetchChatsMoveToArchiveDesktop };
